import { render, staticRenderFns } from "./editable-passenger-field.vue?vue&type=template&id=01f1e356"
import script from "./editable-passenger-field.vue?vue&type=script&lang=js"
export * from "./editable-passenger-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports